export const brand = {
  name: 'Atlas Kinesio-Visual',
  promise: '100 Mapas Visuales:',
  promiseAccent: 'Lo que Aprendes en Meses, Ahora en Horas',
  subtitle:
    'Domina el análisis de +100 ejercicios y obtén la seguridad para explicar, evaluar y aprobar en solo 7 días',
}

export const heroBadges: string[] = ['Acceso inmediato', 'Imprimible', 'Tuyo de por vida']

export const checkoutNote = 'El cargo se realizará en tu moneda local al tipo de cambio del día.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '2.800+', label: 'estudiantes aprobaron con esto' },
  { value: '15+', label: 'universidades latinoamericanas' },
  { value: '200+', label: 'profesores lo recomiendan' },
  { value: '4.9/5', label: 'satisfacción' },
]

export const universities: string[] = ['UBA', 'UNLP', 'UNMDP', 'UNER', 'UCC']

export interface PainGroup {
  audience: string
  points: string[]
}

export const painGroups: PainGroup[] = [
  {
    audience: 'Si eres estudiante',
    points: [
      'Lees 500 páginas y no retienes nada',
      'Tienes el examen encima y estás en pánico',
      'Sabes la teoría, pero al analizar un ejercicio en vivo te quedas en blanco',
    ],
  },
  {
    audience: 'Si eres profesor o entrenador',
    points: [
      'Tus alumnos preguntan anatomía y no respondes con seguridad',
      'Ves el error pero no puedes explicar el por qué',
      'Tienes miedo de lesionar a alguien por una duda tuya',
    ],
  },
]

export const solutionPoints: string[] = [
  '100 mapas visuales: cada ejercicio entendido en 60 segundos, no en 500 páginas',
  '100 análisis de ejercicios reales, los que ves todos los días en la sala',
  'Organizado por patrón de movimiento: entiendes la lógica, no casos sueltos',
  'Músculos, planos y errores técnicos marcados, con la corrección al lado',
  '6 bonos que te enseñan cómo estudiar y cómo explicar, no solo qué',
]

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Tren Inferior',
    detail: '40 mapas + 40 análisis',
    summary: 'Sentadilla, peso muerto, hip thrust, estocadas, prensa y todas sus variantes.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Tren Superior',
    detail: '40 mapas + 40 análisis',
    summary: 'Empujes y tracciones: press, flexiones, dominadas, remos, jalones y aislados.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Core y Estabilización',
    detail: '20 mapas + 20 análisis',
    summary: 'Planchas, anti-rotación, dead bug, bird dog y control lumbo-pélvico.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Músculos principales y secundarios',
  'Planos anatómicos y cadenas cinéticas',
  'Errores comunes y cómo corregirlos',
  'Variaciones y tip de aplicación',
]

export interface GalleryItem {
  title: string
  caption: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    title: 'Sentadilla Libre',
    caption: 'Músculos primarios, estabilizadores, plano anatómico y los 4 errores más comunes.',
    image:
      'https://cdn.magicpatterns.com/uploads/x16G55354PNNAtheNnT81d/Captura_de_pantalla_2026-09-09_a_la(s)_10.22.01_p._m..png',
  },
  {
    title: 'Sentadilla Búlgara',
    caption: 'Trabajo unilateral: qué se estabiliza, qué se compensa y cómo corregirlo.',
    image:
      'https://cdn.magicpatterns.com/uploads/abSn6PaS7zBntMbKZhbhoy/Captura_de_pantalla_2026-09-09_a_la(s)_10.22.11_p._m..png',
  },
  {
    title: 'Press Inclinado',
    caption: 'Porción clavicular, manguito rotador y la trayectoria correcta de la barra.',
    image:
      'https://cdn.magicpatterns.com/uploads/qMb5njumWRBJHTUdnEaLQH/Captura_de_pantalla_2026-09-09_a_la(s)_10.22.28_p._m..png',
  },
  {
    title: 'Crossover',
    caption: 'Aducción horizontal en plano transversal y control de la tensión en el pectoral.',
    image:
      'https://cdn.magicpatterns.com/uploads/mDH7U6vBLxAeDoh5v3o62L/Captura_de_pantalla_2026-09-09_a_la(s)_10.22.38_p._m..png',
  },
  {
    title: 'Remo con Barra',
    caption: 'Retracción escapular, cadena posterior y por qué el balanceo arruina el ejercicio.',
    image:
      'https://cdn.magicpatterns.com/uploads/1xEJGP9VfofbgVATzJ4SBG/Captura_de_pantalla_2026-09-09_a_la(s)_10.22.55_p._m..png',
  },
]

export const comparisonRows: { old: string; atlas: string }[] = [
  { old: '3-4 meses de estudio', atlas: 'Lo dominas en 7 días' },
  { old: 'Lees todo y no retienes nada', atlas: 'Retienes porque es visual' },
  { old: 'Ejercicios sueltos y memorizados', atlas: 'Entiendes patrones y lógica' },
  { old: 'Entras al examen con miedo', atlas: 'Entras con seguridad' },
  { old: 'Manuales de US$30 a US$60+', atlas: 'US$13.90 con US$28.00 en bonos' },
]

export interface Bonus {
  tag: string
  title: string
  value: string
  benefit: string
}

export const bonusesTotalValue = 'US$28.00'

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 1',
    title: 'Guía Anti-Bloqueo',
    value: 'US$4.99',
    benefit: 'Scripts listos para explicar cualquier ejercicio sin quedarte en blanco.',
  },
  {
    tag: 'Bono 2',
    title: 'Ruta Kinesio-Visual de 7 Días',
    value: 'US$4.49',
    benefit: 'Qué estudiar cada día, en qué orden, sin saturarte.',
  },
  {
    tag: 'Bono 3',
    title: 'Planificador de Repaso',
    value: 'US$4.49',
    benefit: 'Planes de 7 días, 3 días y 24 horas para cuando el examen ya está encima.',
  },
  {
    tag: 'Bono 4',
    title: 'Checklist de 60 Segundos',
    value: 'US$3.99',
    benefit: 'Analizas cualquier ejercicio, en orden y sin olvidar nada.',
  },
  {
    tag: 'Bono 5',
    title: 'Workbook de Práctica',
    value: 'US$3.99',
    benefit: '20 ejercicios reales con respuestas modelo para practicar como en el examen.',
  },
  {
    tag: 'Bono 6',
    title: 'Diccionario Express',
    value: 'US$2.05',
    benefit: 'Músculos, movimientos y planos explicados en palabras simples.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'LM',
    quote: 'Estudié 2 años sin entender. Con los mapas lo capté en 3 días y aprobé el final con 8.',
    author: 'Lucía M.',
    role: 'Estudiante de Kinesiología',
    city: 'Bogotá',
  },
  {
    initials: 'CT',
    quote:
      'Me daba vergüenza no saber explicar bien los ejercicios. Hoy mis alumnos preguntan y respondo con seguridad.',
    author: 'Carlos T.',
    role: 'Profesor de Educación Física',
    city: 'Ciudad de México',
  },
  {
    initials: 'FS',
    quote: 'Tenía examen al otro día. Estudié con el plan de 24 horas y aprobé. Gracias.',
    author: 'Franco S.',
    role: 'Estudiante de Fisioterapia',
    city: 'Santiago',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cuándo lo recibo?',
    answer: 'En menos de 2 minutos te llega el link de descarga al email. Sin esperas.',
  },
  {
    question: '¿Sirve si soy profesor de Educación Física y no kinesiólogo?',
    answer:
      'Sí. Es movimiento y biomecánica aplicada: sirve a profesores, entrenadores y estudiantes por igual.',
  },
  {
    question: '¿Alcanza para aprobar un examen?',
    answer:
      'Sí, si sigues el plan del Bono 3. Muchos aprobaron parciales y finales solo con esto. No es magia: hay que estudiar.',
  },
  {
    question: '¿Y si no me sirve?',
    answer: 'Tienes 7 días de garantía. Pides el reembolso y listo, sin preguntas.',
  },
]

export const scarcity = {
  total: 50,
  left: 42,
  note: 'Precio solo para los primeros 50.',
  nextPrice: 'US$24.90',
}

export const checkoutUrl = 'https://pay.hotmart.com/V107583299M'

export interface Offer {
  name: string
  summary: string
  includes: string[]
  listPrice: string
  price: string
  discount: string
  savings: string
  cta: string
}

export const offer: Offer = {
  name: 'Atlas Kinesio-Visual — Sistema Completo',
  summary: '100 mapas visuales + 100 análisis de ejercicios + 6 bonos',
  includes: [
    '100 mapas mentales visuales',
    '100 análisis de ejercicios reales',
    'Los 6 bonos completos (US$28.00)',
    'PDF imprimible, acceso de por vida',
  ],
  listPrice: 'US$39.90',
  price: '13.90',
  discount: '65% off',
  savings: 'US$26.00',
  cta: 'Quiero el Atlas completo ahora',
}

export const heroImage = 'https://cdn.magicpatterns.com/uploads/kdsbFZN72xSkvgDaqK5rdi/mockup.webp'
